import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ArrowRightOutlined } from '@ant-design/icons'
import { Col, Menu, Row } from 'antd'

import { contactUsPage, faqPage, logout } from 'src/routes/NamedRoutes'
import { isMobile } from 'src/utils/helper'

import './HelpSection.less'

const HelpSection = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      {!isMobile() && (
        <Row className="help-section">
          <Col span={24}>{t('common:text.need_help')}</Col>
          <Col>
            <a href={faqPage}>{t('common:navigation.read_faq')}</a>{' '}
            {t('common:or')}{' '}
            <a href={contactUsPage()}>{t('common:navigation.contact_us')}</a>
          </Col>
        </Row>
      )}
      {isMobile() && (
        <Menu mode="inline" inlineIndent={10} className="navbar__menu">
          <Menu.Item
            className="navbar__menu-item"
            icon={<ArrowRightOutlined />}
            key="contact_us"
          >
            <a href={contactUsPage()}>{t('common:navigation.contact_us')}</a>
          </Menu.Item>
          <Menu.Item
            className="navbar__menu-item"
            icon={<ArrowRightOutlined />}
            key="logout"
          >
            <Link to={logout}>{t('common:navigation.logout')}</Link>
          </Menu.Item>
        </Menu>
      )}
    </>
  )
}

export default HelpSection
